// extracted by mini-css-extract-plugin
export default {"buildHistoryBtn":"BuildReport_buildHistoryBtn__hzAYh","infoIcon":"BuildReport_infoIcon__Q7gXt","sortHeaderRow":"BuildReport_sortHeaderRow__ps6va"};